// =============================================================================
// constants.js — ค่าคงที่ใช้ร่วมกันในทุก component ของ chat-unified
// =============================================================================

export const PLATFORM = {
  FACEBOOK: 1,
  LINE: 2,
  SHOPEE: 3,
  LAZADA: 4,
};

export const PLATFORM_NAME = {
  1: "Facebook",
  2: "LINE",
  3: "Shopee",
  4: "Lazada",
};

export const PLATFORM_COLOR = {
  1: "#1877F2",
  2: "#06C755",
  3: "#EE4D2D",
  4: "#0F146D",
};

export const PLATFORM_ICON = {
  1: "mdi-facebook",
  2: "mdi-message-text",
  3: "mdi-shopping",
  4: "mdi-cart",
};

export const SEND_API = {
  1: "CoreMessage/send-message-facebook",
  2: "CoreMessage/send-message-line",
  3: "CoreMessage/send-message-shopee",
  4: "CoreMessage/send-message-lazada",
};

export const TAG_STORAGE_KEY = "chat_tags_v1";
